<template>
	<div class='data-block'>

		<div class='data-block__title'>
			{{ title }}
		</div>

		<div class='data-block__content'>
			<slot></slot>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'DataBlock',
		props: {
			title: {
				type: String,
				default: null
			}
		}
	};
</script>

<style scoped>
	.data-block__title {
		border-bottom: 1px solid #ccc;
		color: #333;
		font-size: 1.3rem;
		font-family: 'Roboto Black';
		margin: 20px 0;
		padding-bottom: 10px;
	}
</style>